import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=0c7fcfd5&scoped=true&"
import script from "./DocumentsList.vue?vue&type=script&lang=js&"
export * from "./DocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=0c7fcfd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7fcfd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7fcfd5')) {
      api.createRecord('0c7fcfd5', component.options)
    } else {
      api.reload('0c7fcfd5', component.options)
    }
    module.hot.accept("./DocumentsList.vue?vue&type=template&id=0c7fcfd5&scoped=true&", function () {
      api.rerender('0c7fcfd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/documents/DocumentsList.vue"
export default component.exports